import cn from 'classnames';
import style from './checklist.module.scss';
import { useEffect, useState } from 'react';
import TotalChecks from '@assets/images/Fireboard/Counters/TotalChecks';
import OpenChecks from '@assets/images/Fireboard/Counters/OpenChecks';
import PartialChecks from '@assets/images/Fireboard/Counters/PartiallyPaidChecks';
import PaidChecks from '@assets/images/Fireboard/Counters/PaidChecks';
import UnpaidChecks from '@assets/images/Fireboard/Counters/UnpaidChecks';
import PreAuthChecks from '@assets/images/Fireboard/Counters/PreAuthChecks';
import PendingChecks from '@assets/images/Fireboard/Counters/PendingChecks';
import InprogressChecks from '@assets/images/Fireboard/Counters/InprogressChecks';
import DoneChecks from '@assets/images/Fireboard/Counters/DoneChecks';
import UnassignChecks from '@assets/images/Fireboard/Counters/UnassignChecks';
import CheckedInChecks from '@assets/images/Fireboard/Counters/CheckedInChecks';
import PickedUpChecks from '@assets/images/Fireboard/Counters/PickedUpChecks';
import { useOutletContext } from 'react-router-dom';
import {
  getChecksBasedOnPaidStatus,
  getChecksBasedOnFilters,
} from '@utility/fireboardUtil';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const Counters = props => {
  const {
    checksCount,
    setChecksCount,
    checksRowData,
    currentMode,
    setFilteredCheckListItem,
    setIsPickedUpCol,
    isPickedUpCol,
    currentView,
  } = props;
  const [originalData, setOriginalData] = useState([]);

  const {
    filterByOrderTypes,
    setFiltersState,
    selectedBtn,
    setSelectedBtn,
    isfutureOrderScreen,
    futureOrdersSummary,
  } = useOutletContext();

  useEffect(() => {
    const data = isfutureOrderScreen
      ? futureOrdersSummary
      : filterByOrderTypes();
    if (Array.isArray(data) && data.length > 0) {
      setOriginalData(data);
    }
  }, [isfutureOrderScreen, futureOrdersSummary]);

  const COUNTERSARRAY = {
    DEFAULT: [
      {
        type: 'total',
        label: FLABEL().COUNTER_ALL_CHECKS,
        icon: <TotalChecks />,
        onClick: () => {
          setFilteredCheckListItem(originalData);
          setFiltersState({ paidAndUnpaid: false });
        },
      },
      {
        type: 'open',
        label: FLABEL().COUNTER_OPEN,
        icon: <OpenChecks />,
        onClick: () =>
          setFilteredCheckListItem(checksRowData.filter(x => x.open)),
      },
      {
        type: 'paid',
        label: FLABEL().COUNTER_PAID,
        icon: <PaidChecks />,
        onClick: () =>
          setFilteredCheckListItem(
            getChecksBasedOnPaidStatus(checksRowData, false, false, true)
          ),
      },
      {
        type: 'partial',
        label: FLABEL().COUNTER_PARTIAL_PAID,
        icon: <PartialChecks />,
        onClick: () =>
          setFilteredCheckListItem(
            getChecksBasedOnPaidStatus(checksRowData, false, true, false)
          ),
      },
      {
        type: 'unpaid',
        label: FLABEL().COUNTER_UNPAID,
        icon: <UnpaidChecks />,
        onClick: () =>
          setFilteredCheckListItem(
            getChecksBasedOnPaidStatus(checksRowData, true, false, false)
          ),
      },
      {
        type: 'repost',
        label: FLABEL().COUNTER_REPOST,
        onClick: () => {
          setFilteredCheckListItem(
            checksRowData.filter(x => {
              return x?.tickets?.length > 0 && !x?.isOneDineCheck && x?.open;
            })
          );
        },
      },
    ],
    ON_PREMISE: [
      {
        type: 'total',
        label: FLABEL().COUNTER_ALL_CHECKS,
        icon: <TotalChecks />,
        onClick: () => {
          setFilteredCheckListItem(originalData);
          setFiltersState({ paidAndUnpaid: false });
        },
      },
      {
        type: 'open',
        label: FLABEL().COUNTER_OPEN,
        icon: <OpenChecks />,
        onClick: () =>
          setFilteredCheckListItem(checksRowData.filter(x => x.open)),
      },
      {
        type: 'paid',
        label: FLABEL().COUNTER_PAID,
        icon: <PaidChecks />,
        onClick: () =>
          setFilteredCheckListItem(
            getChecksBasedOnPaidStatus(checksRowData, false, false, true)
          ),
      },
      {
        type: 'partial',
        label: FLABEL().COUNTER_PARTIAL_PAID,
        icon: <PartialChecks />,
        onClick: () =>
          setFilteredCheckListItem(
            getChecksBasedOnPaidStatus(checksRowData, false, true, false)
          ),
      },
      {
        type: 'unpaid',
        label: FLABEL().COUNTER_UNPAID,
        icon: <UnpaidChecks />,
        onClick: () =>
          setFilteredCheckListItem(
            getChecksBasedOnPaidStatus(checksRowData, true, false, false)
          ),
      },
      {
        type: 'repost',
        label: FLABEL().COUNTER_REPOST,
        icon: <PreAuthChecks />,
        onClick: () => {
          setFilteredCheckListItem(
            checksRowData.filter(x => {
              return x?.tickets?.length > 0 && !x?.isOneDineCheck && x?.open;
            })
          );
        },
      },
    ],
    OFF_PREMISE: [
      {
        type: 'total',
        label: FLABEL().COUNTER_ALL_CHECKS,
        icon: <TotalChecks />,
        onClick: () => {
          setFilteredCheckListItem(originalData);
          setFiltersState({ paidAndUnpaid: false });
        },
      },
      {
        type: 'Pending',
        label: FLABEL().COUNTER_PENDING,
        icon: <PendingChecks />,
        onClick: () => {
          setFilteredCheckListItem(
            getChecksBasedOnFilters(checksRowData, 'Pending')
          );
        },
      },

      {
        type: 'In Progress',
        label: FLABEL().COUNTER_IN_PROGRESS,
        icon: <InprogressChecks />,
        onClick: () => {
          setFilteredCheckListItem(
            getChecksBasedOnFilters(checksRowData, 'In Progress')
          );
        },
      },
      {
        type: 'Complete',
        label: FLABEL().COUNTER_DONE,
        icon: <DoneChecks />,
        onClick: () => {
          setFilteredCheckListItem(
            getChecksBasedOnFilters(checksRowData, 'Complete')
          );
        },
      },
      {
        type: 'Picked Up',
        label: FLABEL().COUNTER_PICKED_UP,
        icon: <PickedUpChecks />,
        onClick: () => {
          setFilteredCheckListItem(
            checksRowData?.filter(x => x.status?.status === 'Picked Up')
          );
        },
      },
      {
        type: 'unpaid',
        label: FLABEL().COUNTER_UNPAID,
        icon: <UnpaidChecks />,
        onClick: () =>
          setFilteredCheckListItem(
            getChecksBasedOnPaidStatus(checksRowData, true, false, false)
          ),
      },
      {
        type: 'checkedIn',
        label: FLABEL().COUNTER_CHECKED_IN,
        icon: <CheckedInChecks />,
        onClick: () =>
          setFilteredCheckListItem(checksRowData?.filter(x => x.checkedIn)),
      },
    ],
    OFF_PREMISE_VENUE: [
      {
        type: 'total',
        label: FLABEL().COUNTER_ALL_CHECKS,
        icon: <TotalChecks />,
        onClick: () => {
          setFilteredCheckListItem(originalData);
          setFiltersState({ paidAndUnpaid: false });
        },
      },
      {
        type: 'Pending',
        label: FLABEL().COUNTER_PENDING,
        icon: <PendingChecks />,
        onClick: () => {
          setFilteredCheckListItem(
            getChecksBasedOnFilters(checksRowData, 'Pending')
          );
        },
      },
      {
        type: 'In Progress',
        label: FLABEL().COUNTER_IN_PROGRESS,
        icon: <InprogressChecks />,
        onClick: () => {
          setFilteredCheckListItem(
            getChecksBasedOnFilters(checksRowData, 'In Progress')
          );
        },
      },
      {
        type: 'Complete',
        label: FLABEL().COUNTER_DONE,
        icon: <DoneChecks />,
        onClick: () => {
          setFilteredCheckListItem(
            getChecksBasedOnFilters(checksRowData, 'Complete')
          );
        },
      },
      {
        type: 'Picked Up',
        label: FLABEL().COUNTER_PICKED_UP,
        icon: <PickedUpChecks />,
        onClick: () => {
          setFilteredCheckListItem(
            checksRowData.filter(x => x.status?.status === 'Picked Up')
          );
        },
      },
      {
        type: 'unpaid',
        label: FLABEL().COUNTER_UNPAID,
        icon: <UnpaidChecks />,
        onClick: () =>
          setFilteredCheckListItem(
            getChecksBasedOnPaidStatus(checksRowData, true, false, false)
          ),
      },

      {
        type: 'checkedIn',
        label: FLABEL().COUNTER_CHECKED_IN,
        icon: <CheckedInChecks />,
        onClick: () =>
          setFilteredCheckListItem(checksRowData?.filter(x => x.checkedIn)),
      },
    ],
    TABLE_DELIVERY: [
      {
        type: 'total',
        label: FLABEL().COUNTER_ALL_CHECKS,
        icon: <TotalChecks />,
        onClick: () => {
          setFilteredCheckListItem(originalData);
          setFiltersState({ paidAndUnpaid: false });
        },
      },
      {
        type: 'unassigned',
        label: FLABEL().COUNTER_UNASSIGNED,
        icon: <UnassignChecks />,
        onClick: () =>
          setFilteredCheckListItem(checksRowData?.filter(x => !x.checkedIn)),
      },
      {
        type: 'checkedIn',
        label: FLABEL().COUNTER_CHECKED_IN,
        icon: <CheckedInChecks />,
        onClick: () =>
          setFilteredCheckListItem(checksRowData?.filter(x => x.checkedIn)),
      },
    ],
    FUTURE_ORDERS: [
      {
        type: 'total',
        label: FLABEL().COUNTER_ALL_CHECKS,
        onClick: () => {
          setFilteredCheckListItem(originalData);
          setFiltersState({ paidAndUnpaid: false });
        },
      },
      {
        type: 'open',
        label: FLABEL().COUNTER_OPEN,
        onClick: () =>
          setFilteredCheckListItem(checksRowData.filter(x => x.open)),
      },
      {
        type: 'paid',
        label: FLABEL().COUNTER_PAID,
        onClick: () =>
          setFilteredCheckListItem(
            getChecksBasedOnPaidStatus(checksRowData, false, false, true)
          ),
      },
      {
        type: 'partial',
        label: FLABEL().COUNTER_PARTIAL_PAID,
        onClick: () =>
          setFilteredCheckListItem(
            getChecksBasedOnPaidStatus(checksRowData, false, true, false)
          ),
      },
      {
        type: 'unpaid',
        label: FLABEL().COUNTER_UNPAID,
        onClick: () =>
          setFilteredCheckListItem(
            getChecksBasedOnPaidStatus(checksRowData, true, false, false)
          ),
      },
      {
        type: 'repost',
        label: FLABEL().COUNTER_REPOST,
        onClick: () => {
          setFilteredCheckListItem(
            checksRowData.filter(x => {
              return x?.tickets?.length > 0 && !x?.isOneDineCheck && x?.open;
            })
          );
        },
      },
    ],
  };

  const getFilteredCount = (checks, type) => {
    switch (type) {
      case 'open':
        return checks.filter(check => check.open).length;

      case 'paid':
        return checks.filter(
          check => check.unpaidAmount === 0 && check.paidAmount > 0
        ).length;

      case 'partial':
        return checks.filter(
          check => check.unpaidAmount !== 0 && check.paidAmount > 0
        ).length;

      case 'unpaid':
        return checks.filter(check => check.unpaidAmount === check.totalAmount)
          .length;
      case 'repost':
        return checks.filter(
          check =>
            check?.tickets?.length > 0 && !check?.isOneDineCheck && check?.open
        ).length;

      case 'Pending':
      case 'In Progress':
      case 'Complete':
        return checks.filter(check => check?.status?.status === type).length;
      case 'Picked Up': {
        return checks.filter(check => check?.status?.status === type).length;
      }
      case 'checkedIn':
        return checks.filter(check => check.checkedIn).length;
      case 'total':
        return sessionStorage.getItem('chequeCount');
      case 'unassigned':
        return checks.filter(check => !check.checkedIn).length;
      default:
        return 0;
    }
  };
  const buttons = COUNTERSARRAY[currentMode] || COUNTERSARRAY['DEFAULT'];

  const getChecksCountFromData = checks => {
    const types = [
      'total',
      'open',
      'paid',
      'partial',
      'unpaid',
      'repost',
      'Pending',
      'In Progress',
      'Complete',
      'Picked Up',
      'checkedIn',
      'unassigned',
    ];

    const counts = {};
    types.forEach(type => {
      counts[type] = getFilteredCount(checks, type);
    });

    return counts;
  };

  useEffect(() => {
    setChecksCount(
      getChecksCountFromData(
        isfutureOrderScreen ? futureOrdersSummary || [] : checksRowData || []
      )
    );
  }, [checksRowData, futureOrdersSummary, isfutureOrderScreen]);

  const renderCounter = btn => {
    return (
      <div
        className={cn(
          style.checkCount,
          'col-12 h-100 d-flex align-items-center',
          selectedBtn === btn.type && btn.type !== 'total'
            ? style.activeBtn
            : ''
        )}
      >
        <div className={cn(style.counterLabel, 'pl-1 text-center w-100')}>
          <div
            className={cn(
              style.count,
              selectedBtn === btn.type && btn.type !== 'total'
                ? style.activeCount
                : ''
            )}
          >
            {checksCount?.[btn.type]}
          </div>
          <div
            onClick={() => {
              setSelectedBtn(prev => {
                const totalBtn = buttons.find(b => b.type === 'total');

                if (btn.type === 'total') {
                  btn.onClick?.();
                  return 'total';
                }

                if (prev === btn.type) {
                  totalBtn?.onClick?.();
                  return 'total';
                } else {
                  btn.onClick?.(checksRowData, props.filteredCheckListItem);
                  return btn.type;
                }
              });
              // handle for colunm change in order status manager
              if (
                btn.type === 'Picked Up' &&
                currentView === 'orderStatusManger'
              ) {
                setIsPickedUpCol(!isPickedUpCol);
              } else {
                setIsPickedUpCol?.(false);
              }
            }}
          >
            {btn.label}
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={cn('pt-2', style.counters)}>
      <div
        className={cn(
          'row mx-0 col-12',
          style.countersConatiner,
          currentMode === 'TABLE_DELIVERY' && style.tableDeliveryCounter
        )}
      >
        {buttons?.map((btn, index) => (
          <div
            className={cn(style.actionBtnContainer, 'row col p-1 mx-0 h-100')}
          >
            {renderCounter(btn)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Counters;
